import constantsCommons from './constantsCommons';

export default {
  STATION_KEYS: {
    VERSION: ['serialNumber', 'hardwareVersion', 'CPUVersion', 'BMSVersion'],
    SATELLITE: ['satellite', 'azimut', 'elevation', 'LNBTilt'],
    MEASURES: [
      'isWLHActive',
      'isNLHActive',
      'isWLVActive',
      'isNLVActive',
      'isWUHActive',
      'isNUHActive',
      'isWUVActive',
      'isNUVActive',
    ],
  },
  SIGNALS: ['NLH', 'NLV', 'NUH', 'NUV', 'WLH', 'WLV', 'WUH', 'WUV'],
  BATTERIES: ['vbat'],
  SIGNALS_STATUS: {
    OK: 'OK',
    LOW: 'LOW',
    DISCONNECTED: 'DISCONNECTED',
  },
  SIGNALS_STATUS_AS_INT: {
    OK: 10,
    LOW: 5,
    DISCONNECTED: 1,
  },
  BATTERY_STATUS: {
    OK: 'OK',
    LOW: 'LOW',
  },
  BATTERY_STATUS_AS_INT: {
    OK: 10,
    LOW: 1,
  },
  BASE_STATUS: {
    OK: 'OK',
    LOW: 'LOW',
    DISCONNECTED: 'DISCONNECTED',
  },
  BASE_STATUS_AS_INT: {
    OK: 10,
    LOW: 1,
    DISCONNECTED: 1,
  },
  COLORS: [
    '#e77c8d',
    '#c69255',
    '#98a255',
    '#56ad74',
    '#5aa9a2',
    '#5ea5c5',
    '#a291e1',
    '#e274cf',
  ],
  MAPBOX: {
    STYLE_URL: 'mapbox://styles/mapbox/',
    STYLES: {
      STREETS: 'streets-v11',
      SATELLITE: 'satellite-v9',
    },
  },
  ENTITIES: {
    SATELLITES: {
      entitiesName: 'satellites',
      entityName: 'satellite',
      i18nEntityName: 'Satellites',
      i18nFormScreenName: 'SatelliteForm',
      PATH_ENTITIES: '/satellites',
      PATH_ADD_ENTITY: '/satellites/new',
    },
    STATIONS: {
      i18nEntityName: 'Station',
      entitiesName: 'stations',
      i18nFormScreenName: 'StationForm',
      PATH_ENTITIES: '/stations',
    },
    RBV3: {
      entitiesName: 'Rainboxesv3',
      entityName: 'Rainboxv3',
      i18nEntityName: 'Rainboxesv3',
      PATH_ENTITIES: '/rbv3s',
    },
  },
  ...constantsCommons,
};
